import React from "react";
import AppTheme from "../../../service/app_config/AppTheme";

type PropsListing = {
  className?: string;
  children?: React.ReactNode;
  isModal?: boolean;
  fixedHieght?: boolean;
};

export const Listing: React.FC<PropsListing> = ({
  className = "",
  children,
  isModal = false,
  fixedHieght = false,
}) => {
  return (
    <div
      className={`theme-listing ${className} ${
        isModal ? "modal-listing" : ""
      } ${fixedHieght ? "fixed-height" : ""}`}
    >
      {children}
    </div>
  );
};

export const ListItem: React.FC<PropsListing> = ({
  className = "",
  children,
}) => {
  return (
    <div
      className={`list-item ${className}`}
      style={{ borderBottom: `1px solid ${AppTheme.textField}` }}
    >
      {children}
    </div>
  );
};
